import styled from "styled-components";
import SWReactIcons from "app/components/React/SWReactIcons/SWReactIcons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { BaseFlex } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled(BaseFlex)<{ isActive: boolean }>`
    position: relative;
    width: 100%;
    height: 42px;
    padding: 12px 20px 10px 14px;
    background-color: ${({ isActive }) => (isActive ? colorsPalettes.carbon[25] : colorsPalettes.carbon[0])};
    text-align: left;
    ${setFontVariant("tooltip")};
    letter-spacing: 0.2px;
    box-sizing: border-box;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
        background-color: ${colorsPalettes.carbon[25]};
    }
`;

export const Icon = styled(SWReactIcons)`
    width: 24px;
    height: 24px;

    path {
        fill: ${colorsPalettes.carbon[200]} !important;
    }
`;

export const TextContainer = styled.div`
    max-width: 440px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Name = styled.span`
    margin-left: 12px;
    color: ${colorsPalettes.carbon[500]};
`;

export const Email = styled.span`
    margin-left: 12px;
    color: ${colorsPalettes.carbon[200]};
`;

export const PendingEmail = styled.span`
    color: ${colorsPalettes.carbon[200]};
`;
